export default "__VITE_ASSET__BFRpKlCn__"